<template>
  <div
    class="ad-block"
    id="contema_acg"
  ></div>
</template>

<script>
export default {
  name: 'AdBlock',

  components: {
  },

  props: {
  },

  data () {
    return {}
  },

  mounted () {
    var s1 = document.createElement('script')
    s1.setAttribute('type', 'text/javascript')
    s1.setAttribute('src', '//j.contema.ru/Contema.js')
    s1.addEventListener('load', this.onScriptLoaded)
    this.$el.appendChild(s1)
  },

  computed: {
  },

  methods: {
    onScriptLoaded () {
      window.Contema.load(20069,{adv_format : "banner",adv_size : 1})
    }
  }
}
</script>

<style lang="sass" scoped>
.ad-block
  text-align: center
</style>



// WEBPACK FOOTER //
// AdBlock.vue?152a53b0